module.exports = __webpack_public_path__ + "img/facebook-oficitial16x16.455b32aa.svg";